
// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import axios from "../../api/axiosAuth";
// import { useAuth } from "../../context/AuthContext";

// export default function VerContenido(){

//   const { asignaturaId } = useParams();

//   const { user } = useAuth();


//   const [contenidos,setContenidos] = useState([]);
//   const [loading,setLoading] = useState(false);
//   const [error,setError] = useState("");



//   useEffect(()=>{


//     const cargar = async()=>{


//       if(!asignaturaId || !user)
//         return;



//       try{


//         setLoading(true);



//         const res = await axios.get(
//           `/contenidos/materia/${asignaturaId}`,
//           {
//             params:{
//               grado:user.grado,
//               grupo:user.grupo
//             }
//           }
//         );



//         console.log(
//           "CONTENIDOS:",
//           res.data
//         );



//         setContenidos(
//           Array.isArray(res.data)
//           ? res.data
//           :
//           res.data.contenidos || []
//         );



//       }catch(error){


//         console.error(
//           "Error contenidos",
//           error.response?.data || error
//         );


//         setError(
//           "No se pudieron cargar los contenidos"
//         );


//       }finally{

//         setLoading(false);

//       }


//     };


//     cargar();


//   },[
//     asignaturaId,
//     user
//   ]);




//   if(loading)
//     return <p>⏳ Cargando...</p>



//   if(error)
//     return <p>{error}</p>




//   return (

//     <div className="ver-contenido-container">


//       <h2>
//         Contenidos de la asignatura
//       </h2>



//       {
//         contenidos.length===0

//         ?

//         <p>
//           No hay contenidos disponibles
//         </p>

//         :

//         (

//         <ul>


//         {
//           contenidos.map(c=>(


//             <li key={c.id}>


//               <h3>
//                 {c.titulo}
//               </h3>



//               {
//                 c.descripcion &&
//                 <p>
//                   {c.descripcion}
//                 </p>
//               }




//               {
//                 c.archivo &&

//                 <a

//                 href={c.archivo}

//                 target="_blank"

//                 rel="noopener noreferrer"

//                 >

//                 📥 Abrir archivo

//                 </a>

//               }



//               {
//                 c.enlace &&

//                 <a

//                 href={c.enlace}

//                 target="_blank"

//                 rel="noopener noreferrer"

//                 >

//                 🔗 Ver enlace

//                 </a>

//               }



//             </li>


//           ))
//         }


//         </ul>

//         )

//       }


//     </div>


//   );


// }

//

import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import "../../style/Planeacion.css";
import axios from "../../api/axiosAuth";

const ContenidosEstudiante = () => {
  const { user } = useAuth();

  const [contenidos, setContenidos] = useState([]);
  const [materias, setMaterias] = useState([]);
  const [materiaSeleccionada, setMateriaSeleccionada] = useState("");

  const [periodoActivo, setPeriodoActivo] = useState(null);

  const [mensaje, setMensaje] = useState("");
  const [loading, setLoading] = useState(false);

  /* ==========================================
      PERIODO ACTIVO
  ========================================== */

  useEffect(() => {
    if (!user) return;

    const cargarPeriodoActivo = async () => {
      try {
        const { data } = await axios.get(
          "/contenidos/periodo-activo"
        );

        setPeriodoActivo(data || null);

      } catch (error) {

        console.error(error);

        setPeriodoActivo(null);

      }
    };

    cargarPeriodoActivo();

  }, [user]);

  /* ==========================================
      MATERIAS
  ========================================== */

  useEffect(() => {

    if (!user) return;

    const cargarMaterias = async () => {

      try {

        setLoading(true);

        const { data } = await axios.get(
          "/contenidos/materias"
        );

        const lista =
          Array.isArray(data)
            ? data
            : data.materias || [];

        setMaterias(lista);

        if (lista.length > 0) {

          setMateriaSeleccionada(lista[0].id);

        }

      } catch (error) {

        console.error(
          "Error cargando materias",
          error.response?.data || error
        );

        setMaterias([]);

        setMensaje(
          "No se pudieron cargar las materias."
        );

      } finally {

        setLoading(false);

      }

    };

    cargarMaterias();

  }, [user]);

  /* ==========================================
      CONTENIDOS
  ========================================== */

  useEffect(() => {

    if (!materiaSeleccionada) return;

    const cargarContenidos = async () => {

      try {

        setLoading(true);

        const { data } = await axios.get(
          `/contenidos/materia/${materiaSeleccionada}`
        );

        setContenidos(
          data.contenidos || []
        );

      } catch (error) {

        console.error(
          "Error cargando contenidos",
          error.response?.data || error
        );

        setContenidos([]);

        setMensaje(
          "No se pudieron cargar los contenidos."
        );

      } finally {

        setLoading(false);

      }

    };

    cargarContenidos();

  }, [materiaSeleccionada]);

  /* ==========================================
      VER ARCHIVO
  ========================================== */

  const handleVerArchivo = (archivo) => {

    if (!archivo) return;

    window.open(
      archivo,
      "_blank"
    );

  };

  /* ==========================================
      DESCARGAR
  ========================================== */

  const handleDescargar = (archivo) => {

    if (!archivo) return;

    window.open(
      archivo,
      "_blank"
    );

  };

  return (

    <div className="contenidos-container">

      <h2>
        📘 Mis Guías y Contenidos
      </h2>

      {periodoActivo && (

        <p className="activo">

          📅 Periodo activo:

          <strong>
            {" "}
            {periodoActivo.nombre}
          </strong>

        </p>

      )}

      {mensaje && (

        <p className="mensaje">

          {mensaje}

        </p>

      )}

      <div className="filtros">

        <label>

          Materia

        </label>

        <select

          value={materiaSeleccionada}

          onChange={(e)=>
            setMateriaSeleccionada(e.target.value)
          }

        >

          <option value="">

            Seleccione...

          </option>

          {materias.map((m)=>(

            <option
              key={m.id}
              value={m.id}
            >

              {m.nombre}

            </option>

          ))}

        </select>

      </div>

      {loading ? (

        <p>

          Cargando...

        </p>

      ) : contenidos.length === 0 ? (

        <p className="mensaje">

          No hay contenidos disponibles.

        </p>

      ) : (

        <div className="contenidos-lista">

          {contenidos.map((item)=>(

            <div
              key={item.id}
              className="contenido-card"
            >

              <h4>

                {item.titulo}

              </h4>

              <p>

                {item.descripcion || "Sin descripción"}

              </p>

              <p>

                <strong>Materia:</strong>{" "}

                {item.materia}

              </p>

              <p>

                <strong>Periodo:</strong>{" "}

                {item.periodo}

              </p>

              <p>

                <strong>Fecha:</strong>{" "}

                {new Date(
                  item.created_at
                ).toLocaleDateString("es-CO")}

              </p>

              {item.tipo === "archivo" &&
               item.archivo && (

                <div className="acciones">

                  <button
                    onClick={() =>
                      handleVerArchivo(item.archivo)
                    }
                  >
                    👁️ Ver
                  </button>

                  <button
                    onClick={() =>
                      handleDescargar(item.archivo)
                    }
                  >
                    📥 Descargar
                  </button>

                </div>

              )}

              {item.tipo === "enlace" &&
               item.enlace && (

                <a
                  href={item.enlace}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  🌐 Abrir enlace
                </a>

              )}

              {item.tipo === "video" &&
               item.enlace && (

                <iframe
                  width="100%"
                  height="300"
                  src={item.enlace}
                  title={item.titulo}
                  allowFullScreen
                />

              )}

            </div>

          ))}

        </div>

      )}

    </div>

  );

};

export default ContenidosEstudiante;